import React, { useEffect, useState } from 'react';
import Navbar from '../../components/Navbar';
import ld from '../../images/load.gif';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { setdata } from '../../redux/reducers/userSlice';
import styles from '../../styles/profile.module.css';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Profile() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState([]);
  const [ordersLoading, setOrdersLoading] = useState(false);

  const dispatch = useDispatch();
  const { users } = useSelector((state) => state);

  useEffect(() => {
    if (users?.userdata) {
      setName(users.userdata.name || '');
      setEmail(users.userdata.email || '');
    }
  }, [users]);

  const validate = () => {
    if (!name || !name.trim()) {
      toast.error('Please provide your name', {
        position: 'bottom-right',
        theme: 'colored'
      });
      return false;
    }
    if (name.trim().length < 2) {
      toast.error('Name must be at least 2 characters long', {
        position: 'bottom-right',
        theme: 'colored'
      });
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isValid = validate();
    
    if (isValid) {
      try {
        setLoading(true);
        const res = await axios.put('https://pro-shop-backend.vercel.app/api/users/profile', {
          name: name.trim()
        });
        setLoading(false);
        
        if (res.data.success === true) {
          dispatch(setdata(res.data.user));
          
          if (res.data.user) {
            setName(res.data.user.name);
            setEmail(res.data.user.email);
          }
          
          toast.success(res.data.message || 'Profile updated successfully', {
            position: 'bottom-right',
            theme: 'colored'
          });
        } else {
          toast.error(res.data.message || 'Failed to update profile', {
            position: 'bottom-right',
            theme: 'colored'
          });
        }
      } catch (error) {
        setLoading(false);
        const errorMessage = error.response?.data?.message || 'Something went wrong. Please try again.';
        toast.error(errorMessage, {
          position: 'bottom-right',
          theme: 'colored'
        });
      }
    }
  };

  const getOrders = async () => {
    try {
      setOrdersLoading(true);
      const res = await axios.get('https://pro-shop-backend.vercel.app/api/orders/myorders');
      setOrdersLoading(false);
      
      if (res.data.success === true) {
        setOrders(res.data.message);
      } else {
        toast.error(res.data.message || 'Failed to fetch orders', {
          position: 'bottom-right',
          theme: 'colored'
        });
      }
    } catch (error) {
      setOrdersLoading(false);
      const errorMessage = error.response?.data?.message || 'Failed to fetch orders. Please try again.';
      toast.error(errorMessage, {
        position: 'bottom-right',
        theme: 'colored'
      });
    }
  };

  useEffect(() => {
    getOrders();
  }, []);

  return (
    <div className={styles.profileContainer}>
      <Navbar />
      
      <div className={styles.profileWrapper}>
        <div className={styles.profileSection}>
          <h4 className={styles.sectionTitle}>My Profile</h4>
          <form className={styles.profileForm} onSubmit={handleSubmit}>
            <div className={styles.formGroup}>
              <label htmlFor="myemail" className={styles.formLabel}>
                Email Address
              </label>
              <input
                id="myemail"
                className={`${styles.formInput} ${styles.disabledInput}`}
                value={email}
                type="email"
                disabled
                readOnly
              />
              <small className={styles.helperText}>Email cannot be changed</small>
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="myname" className={styles.formLabel}>
                Full Name
              </label>
              <input
                id="myname"
                className={styles.formInput}
                value={name}
                autoComplete="off"
                onChange={(e) => setName(e.target.value)}
                type="text"
                placeholder="Enter your full name"
                required
              />
            </div>

            {loading ? (
              <button className={styles.submitBtn} disabled>
                <img className={styles.loaderImg} src={ld} alt="loader" />
                <span>Updating...</span>
              </button>
            ) : (
              <button type="submit" className={styles.submitBtn}>
                Update Profile
              </button>
            )}
          </form>
        </div>

        <div className={styles.ordersSection}>
          <h4 className={styles.sectionTitle}>My Orders</h4>
          
          {ordersLoading ? (
            <div className={styles.ordersLoading}>
              <img src={ld} className={styles.loaderImage} alt="loading orders" />
              <p>Loading your orders...</p>
            </div>
          ) : orders.length > 0 ? (
            <div className={styles.tableWrapper}>
              <table className={styles.ordersTable}>
                <thead>
                  <tr>
                    <th>Order ID</th>
                    <th>Date</th>
                    <th>Total</th>
                    <th>Payment</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.map((val, key) => (
                    <tr key={key}>
                      <td className={styles.orderId}>{val._id.slice(0, 8)}...</td>
                      <td>{moment(val.createdAt).format('DD MMM YYYY')}</td>
                      <td>${val.totalPrice}</td>
                      <td>
                        <span className={val.isPaid ? styles.paidBadge : styles.unpaidBadge}>
                          {val.isPaid ? 'Paid' : 'Not Paid'}
                        </span>
                      </td>
                      <td>
                        <span 
                          className={
                            val.status === 'delivered' 
                              ? styles.deliveredBadge 
                              : val.status === 'shipped'
                              ? styles.shippedBadge
                              : val.status === 'cancelled'
                              ? styles.cancelledBadge
                              : styles.pendingBadge
                          }
                        >
                          {val.status || 'pending'}
                        </span>
                      </td>
                      <td>
                        <Link to={`/order/${val._id}`} className={styles.detailsLink}>
                          View Details
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className={styles.noOrders}>
              <div className={styles.noOrdersIcon}>📦</div>
              <p>You haven't placed any orders yet!</p>
              <Link to="/" className={styles.shopLink}>
                Start Shopping
              </Link>
            </div>
          )}
        </div>
      </div>
      
      <ToastContainer
        position="bottom-right"
        theme="colored"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default Profile;